import { render, staticRenderFns } from "./onFileRemove.vue?vue&type=template&id=335ecf6a&scoped=true&"
import script from "./onFileRemove.vue?vue&type=script&lang=js&"
export * from "./onFileRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ecf6a",
  null
  
)

export default component.exports